import {Input, Pipe, PipeTransform} from '@angular/core';
import {ValidationErrors} from '@angular/forms';
import {TranslocoService} from "@ngneat/transloco";
import {LocalizedDatePipe} from "./localized-date.pipe";

@Pipe({
  name: 'errorMessages'
})
export class ErrorMessagesPipe implements PipeTransform {


  @Input() fromControlName?: string;

  constructor(private transloco: TranslocoService,  private localizedDatePipe: LocalizedDatePipe) {
  }

  transform(errors: ValidationErrors | null, key?: string, displayAll: boolean = false): string[] {
    if (!errors) {
      return [];
    }

    if (displayAll) {
      return Object.keys(errors).map((errorKey: string) => this.getErrorMessage(errorKey, key, errors[errorKey]));
    } else {
      const firstErrorKey = Object.keys(errors)[0];
      return firstErrorKey ? [this.getErrorMessage(firstErrorKey, key, errors[firstErrorKey])] : [];
    }
  }


  getErrorMessage(errorType: string, key?: string, params?: any): string {
    if (this.transloco) {
      switch (errorType) {
        case 'couponInvalid':
          return this.transloco.translate('app.register.to.race.apply.coupon.error.does.not.exist');
        case 'emailUniqueInvalid':
          return this.transloco.translate('app.register.to.race.email.is.not.unique');
        case 'required':
          return this.transloco.translate('app.common.error.required');
        case 'maxlength':
          if (key === 'picture') {
            return this.transloco.translate('app.common.error.medium.text.validator');
          } else if (params['requiredLength']) {
            return this.transloco.translate('app.common.error.maxlength', {maxLength: params['requiredLength']})
          } else {
            return this.transloco.translate('app.common.error');
          }
        case 'minlength':
          if (params['requiredLength'] || params['requiredLength'] === 0) {
            return this.transloco.translate('app.common.error.min.length', {value: params['requiredLength']})
          } else {
            return this.transloco.translate('app.common.error');
          }
        case 'max':
          if (params['max'] || params['max'] === 0) {
            return this.transloco.translate(
              'app.common.error.max.value',
              {value: params['max']})
          } else {
            return this.transloco.translate("app.common.error.default")
          }
        case 'min':
          if (params['min'] || params['min'] === 0) {
            return this.transloco.translate(
              'app.common.error.min.value',
              {value: params['min']})
          } else {
            return this.transloco.translate("app.common.error.default")
          }
        case 'email':
          return this.transloco.translate('app.common.error.email');
        case 'alphabetical':
          return this.transloco.translate('app.common.error.alphabetical');
        case 'numerical':
          return this.transloco.translate('app.common.error.numerical');
        case 'pattern':
          return this.transloco.translate('app.common.error.pattern');
        case 'duplicate':
          return this.transloco.translate('app.common.error.duplicate');
        case 'decimal':
          return this.transloco.translate('app.common.error.decimal');
        case 'invalidPhoneNumber':
          return this.transloco.translate('app.common.error.phone');
        case 'length':
          if (key === 'password' || key === 'confirmPassword') {
            return this.transloco.translate(
              'app.common.error.password.length',
              {min: params['min'], max: params['max']})
          }
          return this.transloco.translate('app.common.error');
        case 'uppercase':
          if (key === 'password' || key === 'confirmPassword') {
            return this.transloco.translate(
              'app.common.error.password.uppercase');
          }
          return this.transloco.translate('app.common.error');
        case 'lowercase':
          if (key === 'password' || key === 'confirmPassword') {
            return this.transloco.translate(
              'app.common.error.password.lowercase')
          }
          return this.transloco.translate('app.common.error');
        case 'digit':
          if (key === 'password' || key === 'confirmPassword') {
            return this.transloco.translate(
              'app.common.error.password.digit')
          }
          return this.transloco.translate('app.common.error');
        case 'special':
          if (key === 'password' || key === 'confirmPassword') {
            return this.transloco.translate(
              'app.common.error.password.special',
              {special: params['chars'].split("").join("  ")})
          }
          return this.transloco.translate('app.common.error');
        case 'whitespace':
          if (key === 'password' || key === 'confirmPassword') {
            return this.transloco.translate(
              'app.common.error.password.whitespace')
          }
          return this.transloco.translate('app.common.error');
        case 'date':
          if (key === "time") {
            return this.transloco.translate(
                'app.common.error.time.min',
                {date: this.localizedDatePipe.transform(params['min'], 'dd.MM.yyyy HH:mm:ss.SSS')});
          }
          if (key === 'from') {
            return this.transloco.translate('app.common.error.start.date')
          }
          if (key === "to") {
            return this.transloco.translate('app.common.error.end.date')
          }
          return this.transloco.translate('app.common.error.default');
        case 'paymentDataMissing':
          if (params === 'iban') {
            return this.transloco.translate('app.common.error.payment.data.missing.iban');
          }
          else {
            return this.transloco.translate('app.common.error.payment.data.missing');
          }
        case 'mandatoryPaymentMissing':
          return this.transloco.translate("app.common.error.mandatory.payment.missing",{field: this.transloco.translate("event.payment.settings.mandatory.payment")} );
        case 'groupRegistrationPaymentEnabled':
          return this.transloco.translate("app.common.error.group.registration.payment.enabled",{races: params} );
        default:
          return this.transloco.translate('app.common.error.default');
      }
    } else {
      return "";
    }
  }
}
